export interface ResidenceCrous {
  id?: number
  nom: string
  adresse: string
  code_commune?: string
  longitude?: number
  latitude?: number
  capacite_extrait?: string | null
  date_traitement?: string | null
  date_metadata?: string | null
  fiche?: {
    description_courte?: string | null
    description?: string | null
    zone?: string | null
    region?: string | null
    services?: string[]
    services_source?: string | null
    contact?: string | null
    telephone?: string | null
    courriel?: string | null
    horaires?: string | null
    liens?: Record<string, string>
  }
}

export const LIBELLE_CROUS = 'Résidences universitaires (CROUS)'

// Les résidences ne s'offrent que sur les thématiques qui en parlent (Cyrille, 20/10 : « elle
// ne doit apparaître que lorsqu'elle est utile pour venir informer la carte »). Le CROUS est
// cité dans log-1 (Parc de logements) : la thématique Logement, seule, pour l'instant.
export const THEMES_CROUS: readonly string[] = ['log']
export const crousUtile = (theme: string | null | undefined): boolean => !!theme && THEMES_CROUS.includes(theme)
export const COULEUR_CROUS = '#475D75'

// Les liens viennent d'une publication extérieure. Seuls HTTP et HTTPS sont navigables.
export function lienCrous(valeur: string | undefined): string | null {
  if (!valeur) return null
  try {
    const url = new URL(valeur)
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null
  } catch { return null }
}
